// extracted by mini-css-extract-plugin
export default {"body":"style_body__tXr7e","trigger":"style_trigger__bAV2z"};